import PropTypes from 'prop-types';

import styles from './styles/styles.module.css';

function Preloader({ className, width, height, innerColor }) {
  return (
    <section className={`${className || ''}`}>
      <div
        className={styles.preloader}
        style={{
          width,
          height,
          '--inner-color': innerColor,
        }}
      />
    </section>
  );
}

Preloader.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  innerColor: PropTypes.string,
};

export default Preloader;
